import React, { useEffect, useState } from "react";
import { FormInput } from "../../wrappers/formInput";
import classnames from "classnames";
import * as CONSTANTS from '../../utils/CONSTANTS'
import Styles from "./styles.module.scss"
import { DropDownInput } from "../../wrappers/selectInput";
import DropDownListselect from "../../components/dropdown";
import { PreventableEvent } from "@progress/kendo-react-charts/dist/npm/events/preventable-event";
import { Label } from "@progress/kendo-react-labels";


interface props {
  setAdditionInputChange?: any;
  remove?: any;
  control?: any;
  removeID?: any;
  showValidationMessage?: any;
  keyId?: any;
  additionalInput?: any;
  setNoerror?: any;
  CurrencyType?: any;
  billingType?: any;
  defaultValues?: any;
  changeDisabled?: any;
  disabled?: any;

}

const AdditionalInputFormField: React.FC<props> = ({
  setAdditionInputChange,
  control,
  remove,
  removeID,
  showValidationMessage,
  keyId,
  additionalInput,
  setNoerror,
  CurrencyType,
  billingType,
  defaultValues,
  changeDisabled,
  disabled,

}) => {

  const [errorReason, SetErrorReason] = useState<any>(defaultValues.reason ? '' : 'Field is Required');
  const [errorValue, SetErrorValue] = useState<any>(defaultValues.amount ? '' : 'Field is Required');
  const [keyid, Setkeyid] = useState<any>(keyId);

  const [amount, setAmount] = useState(defaultValues.amount ? defaultValues.amount : '');
  const [reason, SetReason] = useState(defaultValues.reason ? defaultValues.reason : '')

  const [is_value, setIs_Value] = useState(defaultValues.value ? true : false);
  const [is_reason, SetIs_Reason] = useState(defaultValues.reason ? true : false);
  const [is_type, SetIs_Type] = useState(defaultValues.type ? true : false);
  const [deduction, setDeduction] = useState<any>({
    id: keyid,
    reason: defaultValues.reason ? defaultValues.reason : '',
    amount: defaultValues.amount ? defaultValues.amount : 0,
    type: defaultValues.type ? defaultValues.type : 'Deduction',
    deductionId: defaultValues.deduction_id ? defaultValues.deduction_id : keyId,
    percentage: 0
  });

  useEffect(() => {


    setAdditionInputChange(  additionalInput);
    if (defaultValues.reason == '') {
      additionalInput.push(deduction);
      setNoerror(false)
    }
    else {
      SetIs_Reason(true);
      setIs_Value(true);
      SetIs_Type(true);

    }
  }, [])

  useEffect(() => {
    if (disabled) {
      SetIs_Reason(true);
      setIs_Value(true);
      SetIs_Type(true);
      changeDisabled();
    }
  }, [disabled])

  useEffect(() => {
    const n = additionalInput.map((item: any) => {
      if (item.id == keyid) {

        return deduction;
      } else {
        return item;
      }
    })
    setAdditionInputChange(n);

  }, [deduction])


  const onChangetype = (e: any) => {
    
    setDeduction({ ...deduction, type: e.target.value.name })
    const n = additionalInput.map((item: any) => {
      if (item.id == keyid) {
        return deduction;
      } else {
        return item;
      }
    })
    setAdditionInputChange(n);

  }
  const onChangeReason = (e: any) => {

    e.preventDefault();
    if (e.target.value == '') {
      SetErrorReason('Field is Required')
      setNoerror(false)
    }
    else {
      SetErrorReason('')
      if (errorValue == '') {
        setNoerror(true)
      }
    }
    setDeduction({ ...deduction, reason: e.target.value })


  }
  const onChangeValue = (e: any) => {

    e.preventDefault()
    if (e.target.value == '') {
      SetErrorValue('Field is Required')
      setNoerror(false)
    }
    else {
      SetErrorValue('')
      if (errorReason == '') {
        setNoerror(true)
      }
    }
    setDeduction({ ...deduction, amount: parseInt(e.target.value) })
 
  }
  const onremove = (e: any) => {
    e.preventDefault()

  }
  let typedefault = { "id": 1, "name": "Deduction" };
  if (defaultValues.type == 'Addition') {
    typedefault = { "id": 2, "name": "Addition" };
  }
  
  return (
    <div className={deduction.type === 'Deduction' ? classnames(Styles.deductions, Styles.deduction) : classnames(Styles.deductions, Styles.additions)}>
      <div className={classnames(Styles.currencyFiled, "form-group")}>
      <label className="lablel">Type</label>
        <DropDownListselect
          name="type"
          onChange={onChangetype}
          data={[
            { "id": 1, "name": "Deduction" },
            { "id": 2, "name": "Addition" }]}
          textField="name"
          dataItemKey="id"
          disabled={is_type}
          // label=""
          defaultValue={typedefault}
        />

      </div>
      <div className={classnames(Styles.reasonFiled, "form-group")}>
        <FormInput
          id="reason"
          name="reason"
          label="Reason"
          placeholder="Enter the reason"
          onChange={onChangeReason}
          type="text"
          defaultValue={reason}
          disabled={is_reason}
        />
        <p className="redtext">{showValidationMessage ? errorReason : ''}</p>
      </div>
      <div className={classnames(Styles.amountFiled, "form-group")}>
        <FormInput
          id="amount"
          name="amount"
          label="Amount"
          placeholder="Enter amount"
          onChange={onChangeValue}
          type="number"
          defaultValue={amount}
          disabled={is_value}
        />
        <p className="redtext">{showValidationMessage ? errorValue : ''}</p>
      </div>
      {/* <div className={classnames(Styles.billingFiled, "form-group")}> */}
        {/* <label className="lablel">Billing Type</label> */}

        {/* <DropDownInput
          name="billingType"
          label="Billing Type"
          control={control}
          data={CONSTANTS.timeBasisList}
          disabled={true}
          defaultValue={billingType}
        />
      </div> */}

      <div className={classnames(Styles.currencyFiled, "form-group")}>

        <DropDownInput
          name="currencyType"
          label="Currency Type"
          control={control}
          data={CONSTANTS.currencyTypeList}
          disabled={true}
          defaultValue={CurrencyType}
        />
      </div>

      {/* {!is_value &&  <div className={Styles.currencyFiledRemove}>
        <button type='button' className="k-button k-button-md k-button-rectangle k-button-flat k-button-flat-base k-rounded-md  k-icon-button  border-2 btntop2" onClick={(e) => { onremove(e); remove(removeID); }}>
          <span role="presentation" className="k-button-icon k-icon k-i-x"></span>
        </button>
      </div>} */}
    </div>
  )
}

export default AdditionalInputFormField;

